<script setup lang="ts">
  import { computed } from 'vue'
  import { Select } from "@/components/episto-ui/select";

  const COMMON_FONTS = [
    'Arial', 'Arial Black', 'Calibri', 'Cambria', 'Century Gothic',
    'Courier New', 'Franklin Gothic Medium', 'Futura', 'Garamond',
    'Georgia', 'Gill Sans', 'Helvetica', 'Impact', 'Inter',
    'Lato', 'Montserrat', 'Open Sans', 'Oswald', 'Palatino',
    'Poppins', 'Raleway', 'Roboto', 'Tahoma', 'Times New Roman',
    'Trebuchet MS', 'Verdana',
  ]

  const props = defineProps<{
    modelValue: string | null
    detectedFonts?: string[]
  }>()

  const emit = defineEmits<{ 'update:modelValue': [value: string | null] }>()

  const fontOptions = computed(() => {
    const detected = props.detectedFonts ?? []
    const commonNotDetected = COMMON_FONTS.filter((f) => !detected.includes(f))

    if (detected.length === 0) {
      return commonNotDetected.map((f) => ({ value: f, label: f }))
    }

    return [
      ...detected.map((f) => ({ value: f, label: f })),
      { value: '__separator__', label: '', separator: true },
      ...commonNotDetected.map((f) => ({ value: f, label: f })),
    ]
  })
</script>

<template>
  <Select
    class="mt-1"
    :model-value="modelValue ?? ''"
    :options="fontOptions"
    filterable
    clearable
    placeholder="Default"
    @update:model-value="(v) => emit('update:modelValue', v ? String(v) : null)" />
</template>
